import { ADD_DISCOUNT, UPDATE_SALE, VIEW_DISCOUNT } from "./apiRoutes";
import { adminUsersServices, catalogServices } from "./apiServices";

export const viewDiscount = async (data: object) => {
    const response = await adminUsersServices.post(VIEW_DISCOUNT, data);
    return response?.data;
};

export const addDiscount = async (data: object) => {
    const response = await adminUsersServices.post(ADD_DISCOUNT, data);
    return response?.data;
};

export const updateSaleStatus = async (productId: string, data: object) => {
    const response = await catalogServices.patch(`${UPDATE_SALE}/${productId}`, data);
    return response?.data;
};